import { useMutation, useQueryClient } from "@tanstack/react-query";
import { actualizeazaTargetareContact } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useActualizeazaTargetareContact() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: actualizeazaTargetareContact,
    onSuccess: (_, variabile) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.firma(variabile.cui),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.contacteStats(),
      });
    },
  });
}
